import { useState, useEffect } from 'react';
import { ServicesLoVResponse } from '@/api/generated/api';
import { servicesLoVApi } from '@/api/api';
import { useCurrentSalonStore } from '@/stores/useCurrentSalonStore';

interface UseServicesLoVReturn {
  services: ServicesLoVResponse[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useServicesLoV = (activeOnly: boolean = true): UseServicesLoVReturn => {
  const [services, setServices] = useState<ServicesLoVResponse[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { currentSalon } = useCurrentSalonStore();

  const fetchServices = async () => {
    if (!currentSalon?.salonId) {
      setError('Není vybrán salon');
      return;
    }

    setIsLoading(true);
    setError(null);
    
    try {
      const response = activeOnly 
        ? await servicesLoVApi.getActiveServicesLoV({ salonId: currentSalon.salonId })
        : await servicesLoVApi.getAllServicesLoV({ salonId: currentSalon.salonId });
      
      setServices(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Chyba při načítání služeb:', err);
      setError(err instanceof Error ? err.message : 'Nepodařilo se načíst služby');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (currentSalon?.salonId) {
      fetchServices();
    }
  }, [currentSalon?.salonId, activeOnly]);

  return {
    services,
    isLoading,
    error,
    refetch: fetchServices,
  };
};

